import PageOffices from "@/pages/PageOffices";
import PageHome from "@/pages/PageHome";
import PageJobs from "@/pages/PageJobs";
import PageTeam from "@/pages/PageTeam";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: "/",
            name: "Home",
            component: PageHome,
        },
        {
            path: "/team",
            name: "Team",
            component: PageTeam,
        },
        {
            path: "/jobs",
            name: "Jobs",
            component: PageJobs,
        },
        {
            path: "/offices",
            name: "Offices",
            component: PageOffices,
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: "smooth",
            };
        }
    },
});
